<template> 
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Setup</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col cols="6" class="text-right">
          <el-tooltip content="Add a new Variable Expense" placement="top">
            <base-button type="primary" icon size="sm" @click="addVariableExpense()">
              <span class="btn-inner--text">Add</span>
            </base-button>

          </el-tooltip>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <variable-expense-table></variable-expense-table>
    </b-container>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import VariableExpenseTable from "@/views/Setup/VariableExpenseFolder/VariableExpenseTable";

  export default {
    components: {
      VariableExpenseTable,
      RouteBreadCrumb,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      };
    },
    methods: {
      addVariableExpense(){
        this.$router.push({path: '/setup/addVariableExpense' })
      },
    }
  };
</script>
